export type CheckoutDraft = {
	offerId: string;
	email?: string;
	trialAccepted: boolean;
	yearlyAccepted: boolean;
	source?: "plans" | "account";
	/** Set when the user started checkout from the native iOS app. */
	client?: "ios";
};

const STORAGE_KEY = "unilytics:checkout-draft";

export function saveCheckoutDraft(draft: CheckoutDraft): void {
	if (typeof window === "undefined") return;
	sessionStorage.setItem(STORAGE_KEY, JSON.stringify(draft));
}

export function readCheckoutDraft(): CheckoutDraft | null {
	if (typeof window === "undefined") return null;
	try {
		const raw = sessionStorage.getItem(STORAGE_KEY);
		if (!raw) return null;
		const parsed = JSON.parse(raw) as CheckoutDraft;
		if (!parsed?.offerId || typeof parsed.offerId !== "string") return null;
		return {
			offerId: parsed.offerId,
			email: typeof parsed.email === "string" ? parsed.email : undefined,
			trialAccepted: Boolean(parsed.trialAccepted),
			yearlyAccepted: Boolean(parsed.yearlyAccepted),
			source: parsed.source === "account" ? "account" : "plans",
			client: parsed.client === "ios" ? "ios" : undefined,
		};
	} catch {
		return null;
	}
}

export function clearCheckoutDraft(): void {
	if (typeof window === "undefined") return;
	sessionStorage.removeItem(STORAGE_KEY);
}
